import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that ensures a location control does not hold the same value as another location control.
 * @param otherControlName - The sibling control name to compare against
 */
export function locationNotSameAsValidator(otherControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined) {
      return null;
    }
    const otherControl = control.parent?.get(otherControlName);
    if (otherControl === null || otherControl === undefined || otherControl.value === null || otherControl.value === undefined) {
      return null;
    }
    if (control.value === otherControl.value) {
      return { locationSameAsOther: true };
    }
    // If the other control previously had this error, re-validate it now that this one changed
    if (otherControl.errors?.['locationSameAsOther']) {
      otherControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    return null;
  };
}
